import { I18n } from "@/i18n/I18n";
import { CUSTOM_FIELD_TYPES } from "@/types/customFieldTypes";
import React from "react";
import { Form } from "react-bootstrap";
import { Select } from "../Select";

export const defaultTypeOptions = [
  CUSTOM_FIELD_TYPES.String,
  CUSTOM_FIELD_TYPES.MultilineText,
  CUSTOM_FIELD_TYPES.Integer,
  CUSTOM_FIELD_TYPES.Float,
  CUSTOM_FIELD_TYPES.Boolean,
  CUSTOM_FIELD_TYPES.File,
  CUSTOM_FIELD_TYPES.Object,
];

export function FieldTypeSelect(props: {
  onFieldSelect: (fieldType: CUSTOM_FIELD_TYPES) => void,
  fieldType: CUSTOM_FIELD_TYPES | null,
  disabled: boolean,
  typeOptions?: CUSTOM_FIELD_TYPES[],
}) {
  const { onFieldSelect, fieldType, disabled, typeOptions } = props;
  const defaultTypeOptions = [
    CUSTOM_FIELD_TYPES.String,
    CUSTOM_FIELD_TYPES.MultilineText,
    CUSTOM_FIELD_TYPES.Integer,
    CUSTOM_FIELD_TYPES.Float,
    CUSTOM_FIELD_TYPES.Boolean,
    CUSTOM_FIELD_TYPES.File,
    CUSTOM_FIELD_TYPES.Object,
  ];
  const displayOptions = typeOptions ?? defaultTypeOptions;

  const getSelectLabel = () => {
    if (!fieldType) return `-- ${I18n.get('select')} --`;
    return I18n.get(fieldType);
  };

  return (
    <div className='mt-3'>
      <Form.Label>{I18n.get('fieldType')}</Form.Label>
      <Select label={I18n.get('selectFieldType')} value={getSelectLabel()} disabled={disabled}>
        { displayOptions.map((inputFieldType) => (
          <React.Fragment key={inputFieldType}>
            <button type="button" key={inputFieldType} className="w-100 dropdown-item" onClick={() => onFieldSelect(inputFieldType)}>
              {I18n.get(inputFieldType)}
            </button>
          </React.Fragment>
        ))}
      </Select>
    </div>
  );
}
